// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"323":"47a4630d7702549c","811":"9deec2e1ec089a7e"}[chunkId] + ".js";
};